import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=24976168&lang=pug"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports